import React, { useState } from "react";
import "../assets/css/InputSelect.scss";
import { ReactComponent as DropIcon } from '../assets/icons/custom/DownIcon.svg'

const InputSelect = (props) => {
    const [open, setOpen] = useState(false);

    const cssClass = open ? "input-select open" : "input-select";

    const handleClick = (value) => {
        props.handleChange(value);
    };

    return (
        <div className={cssClass} onClick={(e) => setOpen(!open)}>
            <div className="select select-border">
                <div className="active-option">
                    {React.Children.map(props.children, (child) => {
                        if (
                            JSON.stringify(child.props.value) ===
                            JSON.stringify(props.activeOption)
                        ) {
                            const clonedChild = React.cloneElement(child);
                            return clonedChild.props.children;
                        }
                    })}
                </div>

                <div className="list">
                    {props.children.map((child, index) => {
                        const updatedProps = {
                            ...child.props,
                            handleClick: handleClick
                        };
                        const updatedChild = { ...child, props: updatedProps };
                        return updatedChild;
                    })}
                </div>
                <div className="drop-down-icon">
                    <DropIcon />
                </div>
            </div>
        </div>
    );
};

const Option = (props) => (
    <div className="option" onClick={() => props.handleClick(props.value)}>
        {props.children}
    </div>
);

export { InputSelect, Option };
